module.exports = __webpack_public_path__ + "img/2.c8a60d2a.png";